import React from "react";

export default function Disable() {
  return <p className="later">Come back later please...</p>;
}
